import { Box, Container, Grid, Typography } from "@mui/material";

import { ReactComponent as IntuitiveSvg } from "assets/images/homepage/intuitive.svg";
import { ReactComponent as PerformanceSvg } from "assets/images/homepage/performance.svg";
import { ReactComponent as PrimerDesignSvg } from "assets/images/homepage/primer_design.svg";
import { colors } from "theme";

import { KeyFeature } from "./KeyFeature";
import { KeyFeatureProps } from "./type";

const KeyFeatureItems: KeyFeatureProps[] = [
  {
    title: "Expert Primer Design",
    content:
      "Primer design is the foundation of NGS-based panel performance. Our in-house experts leverage the flexibility of Anchored Multiplex PCR (AMP™) chemistry and purpose-built algorithms to ensure our panels achieve consistent primer performance, specificity and coverage with the intended input material.",
    FeatureImage: PrimerDesignSvg,
  },
  {
    title: "Simple and Intuitive",
    content:
      "Assay Marketplace has a simple, intuitive interface that will quickly suggest the optimal panel based on your gene list using our large catalog of functionally tested designs.",
    FeatureImage: IntuitiveSvg,
  },
  {
    title: "Exceptional Performance",
    content:
      "AMP primers function independently, meaning new content can be added to existing panels without compromising assay performance. Our custom panel solutions offer maximum flexibility and unparalleled performance so you can be confident that your targets will be covered.",
    FeatureImage: PerformanceSvg,
  },
];

export const KeyFeatures = () => (
  <Box
    component="section"
    position="relative"
    bgcolor={colors.white}
    pt={{ xs: 3, sm: 4, md: 5, lg: 10 }}
    pb={{ xs: 4, sm: 5, md: 7, lg: 12 }}
  >
    <Container>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        rowGap={4}
        position="relative"
        maxWidth={{ sm: 428, md: "unset" }}
        margin="auto"
      >
        <Typography variant="h1" component="h2" align="center">
          Key Features
        </Typography>
        <Grid container spacing={3} justifyContent="center" component="ul">
          {KeyFeatureItems.map((item: KeyFeatureProps, index: number) => (
            <Grid item xs={12} md={4} key={index} component="li">
              <KeyFeature {...item} />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  </Box>
);
